import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import {withFormsy} from 'formsy-react';
import {sizes, svgs} from 'epic-diesel-common/src/constants';
import {Icon} from 'epic-diesel-common';
import DropList from '../common/DropList';
import styles from './Select.pcss';

class Select extends React.Component {
    static propTypes = {
        className: PropTypes.string,
        name: PropTypes.string,
        value: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
        onChange: PropTypes.func,
        optionValue: PropTypes.string,
        optionLabel: PropTypes.string,
        options: PropTypes.array,
        isPristine: PropTypes.func,
        showRequired: PropTypes.func,
        getErrorMessage: PropTypes.func,
        showError: PropTypes.func,
        disabled: PropTypes.bool
    };

    render() {
        const {className, isPristine, showRequired, disabled, ...extra} = this.props;
        const classes = classNames(styles.select, className, {
            [styles.error]: !isPristine() && showRequired()
        });
        const icon = <Icon className={styles.icon} icon={svgs.CARET_DOWN} size={sizes.XSMALL} />;

        return (
            <DropList
                className={classes}
                activeClass={styles.active}
                icon={icon}
                disabled={disabled}
                {...extra}
            />
        );
    }
}

export default withFormsy(Select);
